<template>
  <div class="pk-archive pk-flex--column">
    <div class="pk-right--overlay"
     style="overflow: auto;padding: 25px 25px 25px 0px"
     :style="isThumbnailColRight ? 'height:150px' : ''">
      <div class="pk-archive__right-overlay">
        <div class="pk-archive-title pk-flex">
          <div class="pk-flex__00auto pk-flex__vh-center"><img :src="expand_metadata ? getIcon('metadata.svg') : getIcon('metadata.svg')"></div>
          <div class="pk-flex__1 pk-flex__vh-center" 
          >
            <a v-b-toggle="'pk-archive-metadata'"
              @click="expand_metadata = !expand_metadata"
              :class="expand_metadata ? '' : 'pk-hide-arrow'"
            >
              <span style="cursor: pointer;" :class="'fa-lg fas fa-caret-down'"></span> <span style="cursor: pointer;"> Metadata</span>
            </a>
            <a v-b-toggle="'pk-archive-metadata'"
              @click="expand_metadata = !expand_metadata"
              :class="!expand_metadata ? '' : 'pk-hide-arrow'"
            >
              <span style="cursor: pointer;" :class="'fa-lg fas fa-caret-right'"></span> <span style="cursor: pointer;"> Metadata</span>
            </a>
          </div>
        </div>
        <b-collapse visible class="collapse show pk-meta-body"
         id="pk-archive-metadata">
          <section v-for="(obj,k) of getMetaInfo()" :key="k"
           style="margin:5px;">
            <div v-if="obj.text && obj.text.indexOf('dummy label') > -1" class="pk-archive-metadata-dummy-label">
              <span>{{ obj.key }}</span>
            </div>
            <div v-if="obj.text && typeof obj.text === 'string' && obj.text.indexOf('dummy label') < 0">
              <label>{{obj.key}}</label><span class="pull-right">{{obj.text}}</span>
            </div>

            <template v-if="obj && typeof obj.text === 'object'">
              <div><label>{{obj.key}}</label></div>
              <div v-for="(v,t) of obj.text" :key="t">
                {{ t + 1 }}: <span class="pull-right">{{v}}</span>
              </div>
            </template>
          </section>
        </b-collapse>
        <div class="pk-archive-row-commentary pk-archive-title pk-flex"
         style="margin-top:25px">
          <div class="pk-flex__00auto pk-flex__vh-center">
            <img :src="getIcon('commentary.svg')" />
          </div>
          <div class="pk-flex__1 pk-flex__vh-center">
            <a v-b-toggle="'pk-archive-commentary'"
              @click="expand_commentary = !expand_commentary"
              :class="expand_commentary ? '' : 'pk-hide-arrow'"
            >
              <span style="cursor: pointer;" :class="'fa-lg fas fa-caret-down'"></span> <span style="cursor: pointer;"> Commentary</span>
            </a>
            <a v-b-toggle="'pk-archive-commentary'"
              @click="expand_commentary = !expand_commentary"
              :class="!expand_commentary ? '' : 'pk-hide-arrow'"
            >
              <span style="cursor: pointer;" :class="'fa-lg fas fa-caret-right'"></span> <span style="cursor: pointer;"> Commentary</span>
            </a>
          </div>
        </div>
        <b-collapse visible class="collapse show pk-meta-body"
         id="pk-archive-commentary" v-html="commentaryInfo">
        </b-collapse>
      </div>
      <div class="pk-right--overlay-spacing"></div>
    </div>

    <div class="pk-flex__00auto pk-flex--column">
      <div class="pk-flex__00auto pk-flex">
        <div class="pk-page-spacing-flex"></div>
        <div class="pk-archive__head">
          <div class="pk-archive-row-1 pk-flex">
            <!-- <img @click="editionType='ae'"
             :src="editionType==='ae' ? getIcon('archiveedition_active.svg') : getIcon('archiveedition.svg')"> -->
            <div 
             @click="openLinkedCE()"
             :class="hasLinkedCE() ? 'pk-archive-CE-button-normal' : 'pk-archive-CE-button-inactive'"
             :title="hasLinkedCE() ? 'open criticle edition' : 'no critical edition available'"
            />
            <div class="pk-archive-ss-title">{{slidesetTitle}}</div>
          </div>

          <div class="pk-archive-row-slideindex">
            <slideIndexNav-view :navList="slideNavItems"
             style="display: flex;"></slideIndexNav-view>
          </div>

          <div class="pk-archive-row-title"> <span class="pk-archive-ss-title">{{slideTitel}}</span>
          </div>

        </div>
        <div class="pk-page-spacing-flex"></div>
        <div class="pk-archive__right">
        </div>
        <!-- <div class="pk-page-spacing-flex"></div> -->
      </div>
    </div>
    <div class="pk-flex__1 pk-flex"
     style="margin:15px 0px 20px 0px">
      <div class="pk-page-spacing-flex"></div>
      <div class="pk-archive-slideset-imageview pk-flex__1 pk-flex--column">
        <div class="pk-flex__00auto pk-flex pk-archive-row-viewnav-group-wrapper">
          <imageNavList-view class="pk-archive-viewnav-group"
           :navList="viewNavItems.filter(a=>a.group===1)"></imageNavList-view>
          <div style="border-left:2px solid #bbb; margin-right:10px;"
           class="pk-archive-viewnav-group"></div>
          <imageNavList-view class="pk-archive-viewnav-group"
           :navList="viewNavItems.filter(a=>a.group===2)"></imageNavList-view>
          <div class="pk-flex__1 pk-flex"
           style="align-content:flex-end; align-items: center;">
            <div class="pk-flex__1"></div>
            <div>current selection:</div>
            <div class="pk-flex__vh-center"
             style="margin-left:5px;padding:0px 10px; border:1px solid rgb(86, 131, 190); height:100%">{{currentSelection}}</div>
          </div>
        </div>
        <div class="pk-flex__1 pk-flex"
         style="margin-top:15px">
          <component class="pk-flex__1"
           :is="mainComponent"
           :inputData="mainComponentData">
          </component>
          <template v-if="showImageViewText">
            <div class="pk-page-spacing-flex"></div>
            <div class="pk-flex__1"
             style="position:relative">
              <div style="position:absolute; width:100%; height:100%;" v-html="getSlideText()">
              </div>
            </div>
          </template>
        </div>
      </div>

      <template v-if="thumbnailItems">
        <div class="pk-page-spacing-flex"></div>
        <div class="pk-archive__right pk-flex--column"
         style="position:relative; margin-top:45px;">
          <b-tabs @input="changeTab">
            <b-tab title="images" class="nav-item" active>
              <div class="pk-flex__1 pk-flex" style="height: 100%">
                <div class="" id="pk-set__images">
                  <div style="position: absolute;width:100%; height:100%">
                    <thumbnail-view id="thumbnail-view" ref="thumbnailView"
                      :items="thumbnailItems"
                      :colCount="3">
                    </thumbnail-view>
                  </div>
                </div>
              </div>
            </b-tab>
            <b-tab title="videos" class="nav-item" v-if="showVideoAnimationTabs">
              <div class="pk-flex__1 pk-flex" style="height: 100%">
                <video-thumbnail-view id="video-thumbnail-view" ref="videoThumbnailView"
                  :items="videoThumbnailItems"
                  :colCount="1">
                </video-thumbnail-view>
              </div>
            </b-tab>
            <b-tab title="animations"  class="nav-item" v-if="showVideoAnimationTabs">
              <div class="pk-flex__1 pk-flex" style="height: 100%">
                <animation-thumbnail-view id="video-thumbnail-view" ref="animationThumbnailView"
                  :items="animationThumbnailItems"
                  :colCount="1">
                </animation-thumbnail-view>
              </div>
              
            </b-tab>
          </b-tabs>

        </div>
      </template>
      <div class="pk-page-spacing-flex"></div>
      <div :style="isThumbnailColRight ? 'width:0px' : 'width:18%'"
       style="transition: width 0.3s ease-out;">
      </div>
      <div v-if="!isThumbnailColRight"
       class="pk-page-spacing-flex"></div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import SlideIndexNav from './SlideIndexNav';
import ViewNav from './ViewNav';
import ThumbnailView from './ThumbnailView';
import VideoThumbnailView from './VideoThumbnailView';
import AnimationThumbnailView from './AnimationThumbnailView';
import ImageView from '../../components/ImageView';
import DeepzoomView from '../../components/DeepzoomView';
import VideoView from '../../components/VideoView';
import AnimationView from '../../components/AnimationView';
import TextView from './TextView';
import SearchResult from '../../components/SearchResult';
import { FudapiService } from '../../utils/fudapi.service';
import Util from '../../utils/util';
import { mapGetters } from 'vuex';
import { Observable, of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

export default Vue.extend({
  components: {
    'slideIndexNav-view': SlideIndexNav,
    'imageNavList-view': ViewNav,
    'thumbnail-view': ThumbnailView,
    'video-thumbnail-view': VideoThumbnailView,
    'animation-thumbnail-view': AnimationThumbnailView,
    'image-view': ImageView,
    'deepzoom-view': DeepzoomView,
    'video-view': VideoView,
    'animation-view': AnimationView,
    'text-view': TextView,
    'result-view': SearchResult
  },

  data() {
    return {
      startLoad: {
        deepestReached: false,
        threads: []
      },
      editionType: 'ae',
      expand_metadata: true,
      expand_commentary: true,
      componentTabSelected: 'images',
      slidesetMeta: [],
      slideMeta: [],
      textSSMeta: [],
    };
  },
  watch: {
    'route.params.ssid'() {
      this.updateSlideset();
    },
    '$route.query.sid'() {
      this.redrawViewNav();
    },
    '$route.query.view'() {
      this.redrawViewNav();
    },
    'activeSlide'() {
      if (!this.activeSlideset) {
        return;
      }
      const sl = this.activeSlide;
      Util.checkStartLoad({
        loadingCount: 0,
        startLoad: this.startLoad,
        retryCondition: () => { 
          return !sl;
        },
        allDoneCallback: () => {
          const oriContent = sl._source['56_slpublnotes'];
          const obj = {
            str: oriContent
          };
          const obs = FudapiService.transformFreetext(obj).pipe(
            mergeMap(() => {
              sl._source['56_slpublnotes'] = obj.str;
              return of({});
            }),
            mergeMap(() => {
              // deal with text for this slide in the set
              for (const linkedSS of sl._source['56_Slide_Sets']) {
                if (linkedSS.slmasssss === this.$route.params.ssid) {
                  const textObj = {str: ''};
                  if (linkedSS.slmassstext) {
                    textObj.str = linkedSS.slmassstext;
                    return FudapiService.transformFreetext(textObj).pipe(
                      mergeMap(() => {
                        linkedSS.slmassstext = textObj.str;
                        return of({});
                      }),
                    );
                  }
                }
              }
              return of({});
            }),
          );
          this.startLoad.threads.push(obs.subscribe(
            () => null,
            err => {
              console.log(err);
            }
          ));
        }
      });
      this.redrawViewNav();
    },
    'activeSlideset'() {
      const ss = this.activeSlideset;
      Util.checkStartLoad({
        loadingCount: 0,
        startLoad: this.startLoad,
        retryCondition: () => { 
          return !ss;
        },
        allDoneCallback: () => {
          const oriContent = ss.doc._source['54_sspublnotes'];
          const obj = {
            str: oriContent
          };
          this.startLoad.threads.push(FudapiService.transformFreetext(obj).subscribe(
            () => null,
            err => {
              console.log(err);
            },
            () => {
              ss.doc._source['54_sspublnotes'] = obj.str;
            }
          ));
        }
      });
      this.redrawPage();
    },
    'slideById'(s) {
      this.$store.dispatch('archive/select.slide', s);
    },
    'activeThumbnail'(a) {
      this.redrawThumbnail();
    }
  },
  created() {
    this.updateSlideset();
  },

  mounted() {
    if (this.$matomo) {
      this.$matomo.trackPageView('Archive Edition Sets Slides');
    }
    this.redrawViewNav();
    this.$store.dispatch('fetchSearchResult');
  },
  destroyed() {
    for (const subscriber of this.startLoad.threads) {
      subscriber.unsubscribe();
    }
  },

  computed: {
    archive() {
      return this.$store.getters.archive;
    },
    viewNavItems() {
      return this.$store.getters['archive/viewNavItems'];
    },
    activeSlideset() {
      return this.$store.getters['archive/activeSlideset'];
    },
    activeSlide() {
      return this.$store.getters['archive/activeSlide'];
    },
    activeViewGroup() {
      return this.$store.getters['archive/activeViewGroup'];
    },

    slideById() {
      const ss = this.activeSlideset;
      if (!ss || !ss.slides) {
        return;
      }
      const id = this.$route.query.sid;
      if (id) {
        return ss.slides.find(s => s._id === id);
      }
    },
    activeThumbnail() {
      // set thumbnail: select slide or slideImage
      if (!this.thumbnailItems) {
        return;
      }
      let slidepos = this.$route.query['thumbnail'];
      if (!slidepos) {
        slidepos = 0;
      }
      const ret = this.thumbnailItems[slidepos];
      return ret;
    },

    slideNavItems() {
      const vue = this;
      const ss = this.activeSlideset;
      if (!ss || !ss.slides) {
        return [];
      }

      const items = [];
      ss.slides.forEach((sl, i) => {
        const pos = sl.$_position;
        const missing = sl.$_missing;
        const imgs = !sl.$_missing
          ? sl.$_images.filter(a => a.dbImageInfo.name)
          : [];
        items.push({
          idx: i + 1,
          title: pos,
          missing: missing,
          selected: false,
          imgs: imgs,
          slide: sl
        });
      });

      items.sort((a, b) => {
        return a.idx - b.idx;
      });

      return items;
    },

    thumbnail_ss() {
      const slideset = this.activeSlideset;
      if (!slideset || !slideset.slides) {
        return;
      }
      const out = [];
      slideset.slides.forEach(slide => {
        out.push({
          type: 'ss',
          document: slide,
          imgObj: slide.$_screenImage
        });
      });
      return out;
    },

    thumbnail_sl() {
      const slide = this.activeSlide;
      if (!slide) {
        return;
      }
      const out = [];
      const viewId = this.activeViewItem.id;
      slide.$_images.forEach(a => {
        if (viewId === 's-objectview' && a.sourcename.match(/detail|screen/g)) {
          return;
        } else if (viewId === 's-imageview' && !a.sourcename.match(/screen/g)) {
          return;
        } else if (viewId === 's-details' && !a.sourcename.match(/detail/g)) {
          return;
        }

        if (a.dbImageInfo.name) {
          out.push({
            type: 'sl',
            key: a.key,
            imgObj: a,
            document: slide
          });
        }
      });
      return out;
    },
    thumbnail_ri() {
      const slideset = this.activeSlideset;
      if (!slideset || !slideset.relatedItems) {
        return;
      }
      const out = [];
      // relatedItem from slideset
      slideset.relatedItems.forEach(ri => {
        ri.$_images.forEach(a => {
          if (a.dbImageInfo.name) {
            out.push({
              type: 'ri',
              key: a.key,
              imgObj: a,
              document: ri
            });
          }
        });
      });
      // todo: related items in Setansicht, als auch Slideansicht
      // todo: ticket #6218, Einbau Filter für Related Items

      return out;
    },
    thumbnail_slri() {
      const slide = this.activeSlide;
      if (!slide || !slide.relatedItems) {
        return;
      }
      const out = [];
      // relatedItem from slideset
      slide.relatedItems.forEach(ri => {
        ri.$_images.forEach(a => {
          if (a.dbImageInfo.name) {
            out.push({
              type: 'slri',
              key: a.key,
              imgObj: a,
              document: ri
            });
          }
        });
      });
      return out;
    },
    thumbnail_slscreen() {
      const slide = this.activeSlide;
      if (!slide || !slide.$_images || slide.$_images.length <= 0) {
        return;
      }
      const out = [];
      // relatedItem from slideset
      slide.$_images.forEach(im => {
        if (im.sourcename.match(/@screen/g)) {
          out.push({
            type: 'slscreen',
            key: im.key,
            imgObj: im,
            document: slide
          });
        }
      });
      out.sort((a, b) => {
        return a.imgObj.order - b.imgObj.order; 
      });
      return out;
    },
    videoThumbnail_sl() {
      const slide = this.activeSlide;
      if (!slide) {
        return [];
      }
      return slide.videos;
    },
    animationThumbnail_sl() {
      const slide = this.activeSlide;
      if (!slide) {
        return [];
      }
      return slide.animations;
    },

    thumbnailItems() {
      if (this.activeViewItem && this.activeViewItem.id === 'ss') {
        return this.thumbnail_ss;
      } else if (
        this.activeViewGroup !== 1 &&
        ['s-relateditems', 's-text', 's-imageview'].indexOf(
          this.activeViewItem.id
        ) < 0
      ) {
        return this.thumbnail_sl;
      } else if (this.activeViewItem.id === 'ss-relateditems') {
        return this.thumbnail_ri;
      } else if (this.activeViewItem.id === 's-relateditems') {
        return this.thumbnail_slri;
      } else if (this.activeViewItem.id === 's-imageview' && !this.viewNavItems.find(a => a.id === 's-text').active) {
        return this.thumbnail_slscreen;
      } 
    },
    videoThumbnailItems() {
      if (this.activeViewItem && this.activeViewItem.id === 'ss') {
        return this.thumbnail_ss;
      } else if (this.activeViewItem && this.activeViewItem.id === 's-objectview') {
        return this.videoThumbnail_sl;
      } 
    },
    animationThumbnailItems() {
      if (this.activeViewItem && this.activeViewItem.id === 'ss') {
        return this.thumbnail_ss;
      } else if (this.activeViewItem && this.activeViewItem.id === 's-objectview') {
        return this.animationThumbnail_sl;
      } 
    },

    activeViewItem() {
      return this.viewNavItems.find(a => a.active === true);
    },

    mainComponent() {
      if (this.componentTabSelected === 'videos') {
        return 'video-view';
      }
      if (this.componentTabSelected === 'animations') {
        return 'animation-view';
      }
      switch (this.activeViewItem.id) {
        case 'searchresult':
          return 'result-view';

        case 'ss':
          return 'image-view';

        case 'ss-text':
          return 'text-view';

        case 'ss-relateditems':
          return 'deepzoom-view';

        case 's-objectview':
          return 'deepzoom-view';

        case 's-details':
          return 'deepzoom-view';

        case 's-imageview':
          return 'deepzoom-view';

        case 's-relateditems':
          return 'deepzoom-view';

        default:
          return null;
      }
    },

    mainComponentData() {
      if (this.componentTabSelected === 'videos') {
        switch (this.activeViewItem.id) {
          case 's-objectview':
            return this.activeSlide.getActiveVideo();
        }
      }
      if (this.componentTabSelected === 'animations') {
        switch (this.activeViewItem.id) {
          case 's-objectview':
            return this.activeSlide.getActiveAnimation();
        }
      }
      if (this.componentTabSelected === 'images') {
        switch (this.activeViewItem.id) {
          case 'ss':
            return this.activeSlide ? this.activeSlide : null;

          case 'ss-text':
            if (!this.activeSlideset) {
              return;
            }
            let out = [];
            this.activeSlideset.texts.forEach(t => {
              out = out.concat(t.$_images);
            });
            return out;

          case 's-details':
            return this.activeSlide ? this.activeSlide.getActiveImage() : null;

          case 's-objectview':
            return this.activeSlide ? this.activeSlide.getActiveImage() : null;

          case 's-imageview':
            return this.activeSlide ? this.activeSlide.getActiveImage() : null;

          case 'ss-relateditems':
            return this.activeThumbnail ? this.activeThumbnail.imgObj : null;

          case 's-relateditems':
            return this.activeThumbnail ? this.activeThumbnail.imgObj : null;
        }
      }
      return undefined;
    },

    isThumbnailColRight() {
      return !this.expand_metadata && !this.expand_commentary;
    },

    commentaryInfo() {
      const ag = this.activeViewGroup;
      if (ag && ag === 1) {
        return this.slidesetCommentary;
      } else if (ag && ag === 2) {
        return this.slideCommentary;
      }
    },

    slidesetCommentary() {
      const current = this.activeSlideset;
      if (!current) {
        return;
      }
      return current.doc._source['54_sspublnotes'];
    },
    slideCommentary() {
      const current = this.activeSlide;
      if (!current || current.$_missing) {
        return;
      }
      const s = current._source;
      return s['56_slpublnotes'];
    },
    slidesetTitle() {
      const current = this.activeSlideset;
      if (!current) {
        return '';
      }
      return current.toShowTitle;
    },

    slideTitel() {
      const c = this.activeSlide;
      if (!c || c.$_missing || this.activeViewGroup === 1) {
        return '';
      }
      return 'Slide ' + c.$_position + ': ' + c._source['56_slmaintitle'];
    },
    currentSelection() {
      return this.activeViewItem.label;
    },
    showImageViewText() {
      return this.viewNavItems.find(v => v.id === 's-text').active;
    },
    showVideoAnimationTabs() {
      const listOfViews = ['s-objectview'];
      if (listOfViews.indexOf(this.activeViewItem.id) > -1) {
        return true;
      } else {
        return false;
      }
    },
  },

  methods: {
    hasLinkedCE() {
      if (this.activeSlideset) {
        if (this.activeSlideset.linkedCE.length > 0) {
          return true;
        }
      }
    },
    openLinkedCE() {
      if (this.hasLinkedCE()) {
        // use the first critical edition
        const url = window.location.href.replace(/\/ae\/?.*/, '/ce/' + this.activeSlideset.linkedCE[0]);
        window.open(url);
      }
    },
    getMetaInfo() {
      const ag = this.activeViewGroup;
      const avid = this.activeViewItem.id;
      if (!avid) {
        return {};
      }

      if (['ss', 'ss-relateditems'].indexOf(avid) > -1) {
        this.makeSlidesetMeta();
        return this.slidesetMeta;
      } else if (['s-objectview', 's-details', 's-imageview', 's-relateditems'].indexOf(avid) > -1) {
        this.makeSlideMeta();
        return this.slideMeta;
      } else if (avid === 'ss-text') {
        this.makeTextSSMeta();
        return this.textSSMeta;
      }
      return {};
    },
    makeSlideMeta() {
      const current = this.activeSlide;
      if (!current || current.$_missing) {
        return {};
      }
      const meta = current.getToShowMetadata();
      for (const key in meta) {
        if (meta[key]) {
          this.slideMeta[key] = meta[key];
        }
      }
      return this.slideMeta;
    },
    makeSlidesetMeta() {
      const current = this.activeSlideset;
      if (!current) {
        return {};
      }
      const meta = current.getToShowMetadata();
      for (const key in meta) {
        if (meta[key]) {
          this.slidesetMeta[key] = meta[key];
        }
      }
      return this.slidesetMeta;
    },
    makeTextSSMeta() {
      const current = this.activeSlideset;
      if (!current) {
        return {};
      }
      if (current.texts.length > 0) {
        const meta = current.texts[0].getToShowMetadata();
        for (const key in meta) {
          if (meta[key]) {
            this.textSSMeta[key] = meta[key];
          }
        }
      }
      return this.textSSMeta;
    },
    changeTab(tabIndex) {
      if (tabIndex === 0) {
        this.componentTabSelected = 'images';
      }
      if (tabIndex === 1) {
        this.componentTabSelected = 'videos';
      }
      if (tabIndex === 2) {
        this.componentTabSelected = 'animations';
      }
    },
    redrawViewNav() {
      //  console.log('redrawViewNav');
      const viewIds = this.$route.query.view;
      this.$store.dispatch('archive/select.navItems', viewIds);
    },

    redrawPage() {
      //        console.log('redrawPage');
      this.redrawViewNav();
    },
    redrawThumbnail() {
      //  console.log('redrawThumbnail');
      this.$store.dispatch('archive/select.thumbnail', this.activeThumbnail);
    },

    updateSlideset() {
      const [vue, id] = [this, this.$route.params.ssid];
      if (!id) {
        return;
      }
      if (id && (!vue.activeSlideset || vue.activeSlideset._id !== id)) {
        vue.$store.dispatch('fetchSelectArchiveEdition', {
          id: id,
          cb: (res) => {
            if (res && res[0]) {
              vue.$store.dispatch('archive/select.slideset', res[0]);
            }
          }
        });
      }
    },
    getIcon(iconName) {
      return this.$getIcon(iconName);
    },
    getSlideText() {
      const sl = this.activeSlide;
      if (sl && sl._source) {
        for (const linkedSS of sl._source['56_Slide_Sets']) {
          if (linkedSS.slmasssss === this.$route.params.ssid) {
            const textObj = {str: ''};
            if (linkedSS.slmassstext) {
              return linkedSS.slmassstext;
            }
          }
        }
      } else {
        return '';
      }
    }
  }
});
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variable.scss';
@import '../../assets/scss/layout.scss';
@import '../../assets/scss/color.scss';
@import '../../assets/scss/size.scss';

.pk-archive-CE-button-normal {
  cursor: pointer;
  width: 25px;
  margin-right: 2px;
  background-image: url('../../assets/icons/criticaledition.svg');
}
.pk-archive-CE-button-normal:hover {
  background-image: url('../../assets/icons/criticaledition_active.svg');
}

.pk-archive-CE-button-inactive {
  cursor: default;
  width: 25px;
  margin-right: 2px;
  background-image: url('../../assets/icons/criticaledition_inactive.svg');
}

.pk-archive-row-comm {
  flex: 0 0 auto;
  line-height: 25px;
  height: 25px;
}

.pk-archive__head {
  flex: 0 0 $pk-container__main-width;
}

.pk-archive__right {
  flex: 0 0 $pk-container__sider-width;
  min-width: 280px;
}

.pk-archive__right-overlay {
  @extend .pk-flex__1;
  .pk-archive-title {
    background-color: rgb(187, 187, 187);
    line-height: 25px;
    a {
      padding-bottom: 5px;
    }
    height: 25px;
    img {
      height: 25px;
      margin-bottom: 1px;
      background-color: #fff;
    }
    * {
      color: #fff;
    }
  }
  .pk-meta-body {
    padding: 10px;
    background-color: rgb(240, 240, 240);
    font-size: 11px;
    width: 100%;
    word-wrap: break-word;
  }
}

.pk-archive-row-1 {
  @extend .pk-archive-row-comm;
  margin-top: 25px;
  img {
    height: 25px;
    width: 25px;
    margin-right: 5px;
  }
  button {
    margin-right: 5px;
    width: 30px;
    display: flex;
    justify-content: center;
  }
}

.pk-archive-row-title {
  @extend .pk-archive-row-comm;
  margin-top: 25px;
  background-color: #d8dff2;
  width: 100%;
}

.pk-archive-row-slideindex {
  @extend .pk-archive-row-comm;
  margin-top: 15px;
}

.pk-archive-row-commentary {
  @extend .pk-archive-row-comm;
}

.pk-archive-row-viewnav-group-wrapper {
  @extend .pk-archive-row-comm;
  height: 30px;
}

.pk-archive-row-main {
  padding: 20px 0;
}

.pk-archive-viewnav-group {
  @extend .pk-flex;
  height: 30px;
}

.pk-archive-ss-title {
  flex: 1;
  display: flex;
  align-content: center;
  background-color: #d8dff2;
  padding-left: 10px;
  font-weight: bold;
}

.pk-archive-metadata-dummy-label {
  background-color: #fff;
  font-weight: 900;
  font-size: 12px;
  margin-top: 10px;
  text-align: center;
  span {
    display: inline-block;
  }
}
</style>
